import React from "react";
import dateFormat from "dateformat";
import { Link } from "react-router-dom";
const SingleItem = ({ data, index, handleLogout }) => {
  return (
    <>
      <tr>
        <td data-label="User">
          <span className="fw-bold">{data?.userId?.fname} {data?.userId?.lname}</span>
          <br />
          <span className="small">

            <Link to={`/admin/users/details/${data?.userId?._id}`}>
              {data?.userId?.uid}
            </Link>
          </span>
        </td>

        <td data-label="Device Id">
          {data?.deviceId}
        </td>
        <td data-label="Platform">
          {data?.platform}
        </td>
        <td data-label="Browser">
          {data?.browser}
        </td>

        <td data-label="Last Active">
          {dateFormat(data?.lastActive, "d-m-yyyy h:MM:ss TT")}
        </td>

        <td data-label="Action">
          <button
            className="btn btn-sm btn-outline-danger ms-1 user-logout-btn"
            onClick={()=>handleLogout(data?._id)}
          >
            <i class="las la-sign-out-alt "></i>Logout
          </button>
        </td>
      </tr>
    </>
  );
};

export default SingleItem;
